import { useContext, useEffect, useState } from "react";
import "./leads.css";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { LEAD_LIST, ADD_LEAD, LEAD_DETAILS, ZOOM_CALLS_LIST, SOURCE_LIST, TEAM_LIST } from "../../global/API";
import { PulseLoader } from "react-spinners";
import { format } from "date-fns";
import CustomModal from "../../components/customModal/customModal";
import { InputMask } from "primereact/inputmask";
import { Calendar } from "primereact/calendar";
import CustomChart from "../../components/customChart/customChart";
import { Dropdown } from "primereact/dropdown";
import { formatDateTime, formatDateTimeNew, formatDateTimeShort, formatUSPhoneNumber } from "../../components/globalFunctions/globalFunctions";
import { Tooltip } from "primereact/tooltip";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const Leads = () => {
  const [leadsList, setLeadsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [changeType, setChangeType] = useState("");
  const [viewLead, setViewLead] = useState([]);
  const [paginationObj, setPaginationObj] = useState({ pageSize: 50, current: 1 });
  const [filteredValues, setFilteredValues] = useState({ searchValue: "", sourceFilter: "", assignedToValue: "" });
  const [leadDates, setLeadDates] = useState({ from: null, to: null });

  const [selectedLeads, setSelectedLeads] = useState([]);
  const [modifiedLeadDetails, setModifiedLeadDetails] = useState({});
  const [activityTab, setActivityTab] = useState("zoomInfo");

  const [zoomCalls, setZoomCalls] = useState({});
  const [zoomCallsLoading, setZoomCallsLoading] = useState({});
  const [zoomFilter, setZoomFilter] = useState("inbound");
  const [dates, setDates] = useState({ from: null, to: null });
  // const [zoomPagination, setZoomPagination] = useState({ pageSize: 100, current: 1 });
  const [zoomSearchValues, setZoomSearchValues] = useState({ searchZoomValue: "" });
  const [sourceList, setSourceList] = useState(null);
  const [clioUserList, setClioUserList] = useState(null);
  const { user } = useContext(AuthContext);
  const [getModalLayout, setGetModalLayout] = useState(null);

  const [hoverContent, setHoverContent] = useState(null);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedLeads((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedLeads.filter((item) => item !== id);
      setSelectedLeads(filteredListing);
    }
  };

  const onHandleEvent = (event, setFunction) => {
    const { name, value } = event.target;
    setFunction((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", selectedLeads[0]);
    formData.append("source", modifiedLeadDetails.source);

    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Accept: "application/json",
        },
      };

      const response = await fetch(ADD_LEAD + selectedLeads[0], options);
      const data = await response.json();

      if (data.status === "Success") {
        setSelectedLeads([]);
        fetchData(paginationObj.current, paginationObj.pageSize);
        navigate(`/leads`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue, sourceFilter, assignedToValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let leadQuery = `?limit=${pageSize}&page=${current}&search=${searchValue}&source=${sourceFilter}&assignedto=${assignedToValue}`;

    if (leadDates?.[0]) {
      leadQuery += `&fdate=${format(new Date(leadDates[0]), "yyyy-MM-dd")}`;
    }
    if (leadDates?.[1]) {
      leadQuery += `&tdate=${format(new Date(leadDates[1]), "yyyy-MM-dd")}`;
    }

    const URL = LEAD_LIST + leadQuery;

    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setLeadsList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLeadDetails = async (id) => {
    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Accept: "application/json",
        },
      };
      const response = await fetch(LEAD_DETAILS + id, options);
      if (response.ok) {
        const data = await response.json();
        if (data.data.phone_numbers) {
          fetchZoomCalls(data.data.phone_numbers);
        }
        if (data.status === "Success") {
          setViewLead((prevState) => [...prevState, data.data]);
        }
      }
    } catch (error) {
      console.log("Error fetching lead details:", error);
    }
  };

  const fetchZoomCalls = async (phone) => {
    setZoomCallsLoading({ [phone]: true });
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?phone_number=${phone}&limit=100&page=1`;

    if (zoomFilter.toLowerCase() !== "all") {
      query += `&call_type=${zoomFilter}`;
    }
    // if (zoomSearchValues.searchZoomValue) {
    //   query += `&search=${zoomSearchValues.searchZoomValue}`;
    // }
    if (dates?.[0]) {
      query += `&fdate=${format(new Date(dates[0]), "yyyy-MM-dd")}`;
    }
    if (dates?.[1]) {
      query += `&tdate=${format(new Date(dates[1]), "yyyy-MM-dd")}`;
    }

    const CALLS_URL = ZOOM_CALLS_LIST + query;

    try {
      const response = await fetch(CALLS_URL, options);
      if (response.ok) {
        const data = await response.json();
        if (data.status === "Success") {
          setZoomCalls((prev) => ({ ...prev, [phone]: data.data }));
        } else {
          setZoomCalls((prev) => ({ ...prev, [phone]: [] }));
        }
      }
    } catch (error) {
      console.log("Error fetching zoom calls:", error);
    } finally {
      setZoomCallsLoading({ [phone]: false });
    }
  };

  const fetchSourceData = async () => {
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    const URL = SOURCE_LIST;
    try {
      const response = await fetch(URL, options);
      const data = await response.json();
      if (data.status === "Success") {
        setSourceList(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAssignedToData = async () => {
    if (user?.role !== 1) return;
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };
    let query = `?status=1`;
    const URL = TEAM_LIST + query;
    try {
      const response = await fetch(URL, options);
      const data = await response.json();
      if (data.status === "Success") {
        setClioUserList(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [paginationObj]);

  useEffect(() => {
    const { searchValue } = filteredValues;
    if (searchValue?.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue, filteredValues.sourceFilter, filteredValues.assignedToValue, leadDates]);

  useEffect(() => {
    if (changeType !== "" || dates) {
      fetchData(1, paginationObj.pageSize);
    }
  }, [changeType, dates]);

  useEffect(() => {
    viewLead.forEach((lead) => {
      if (lead.phone_numbers) {
        fetchZoomCalls(lead.phone_numbers);
      }
    });
  }, [zoomFilter, zoomSearchValues.searchZoomValue, dates]);

  function timeToSeconds(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  useEffect(() => {
    const modifiedLeadData = viewLead.map((lead) => {
      const inBound = { data: [], labels: [] };
      const outBound = { data: [], labels: [] };
      zoomCalls[lead?.phone_numbers]?.forEach((call) => {
        const seconds = timeToSeconds(call.duration);
        if (seconds <= 0) return;

        const label = `${formatDateTimeShort(call.start_time)}<br />Dur - ${call.duration}`;

        if (call.direction === "inbound") {
          inBound.data.push(seconds);
          inBound.labels.push(label);
        } else if (call.direction === "outbound") {
          outBound.data.push(seconds);
          outBound.labels.push(label);
        }
      });
      return { ...lead, inBoundChartData: inBound, outBoundChartData: outBound };
    });
    setViewLead(modifiedLeadData);
  }, [zoomCalls]);

  useEffect(() => {
    fetchSourceData();
  }, []);
  useEffect(() => {
    fetchAssignedToData();
  }, []);

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const leadsListView = () => {
    return (
      <>
        <Tooltip target=".call-count" position="right">
          {hoverContent && (
            <table className="call-count-hover-text table align-middle text-nowrap table-hover table-centered property-table">
              <thead>
                <th>Name</th>
                <th>Date</th>
                <th>Duration</th>
              </thead>
              <tbody>
                {(hoverContent.client_zoom_calls || [])
                  .filter((call) => call.direction === hoverContent.direction)
                  .slice(0, 10)
                  .map((call) => (
                    <tr key={call.id}>
                      <td>{call[hoverContent.direction === "inbound" ? "to_name" : "from_name"] || "--"}</td>
                      <td>{formatDateTime(call.start_time)}</td>
                      <td>{call.duration}</td>
                    </tr>
                  ))}

                {(hoverContent.client_zoom_calls || []).filter((c) => c.direction === hoverContent.direction).length === 0 && (
                  <tr>
                    <td colSpan="3">No inbound calls</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Tooltip>
        {isLoading && leadsList.status === "Success" && <>{leadsLoadingView()}</>}
        {leadsList.data.map((leads) => {
          const { id, name, created_at, emails, phone_numbers, Inbound, Outbound, matters, assignedto, client_zoom_calls, source_name } = leads;

          const progressWidth = Outbound === 0 ? "4px" : `${(Outbound / 12) * 100}%`;
          const barColor = Outbound === 0 ? "red" : Outbound <= 4 ? "red" : Outbound <= 8 ? "orange" : "green";
          const inProgressWidth = Inbound === 0 ? "4px" : `${(Inbound / 12) * 100}%`;
          const inBarColor = Inbound === 0 ? "red" : Inbound <= 4 ? "red" : Inbound <= 8 ? "orange" : "green";
          return (
            <tr key={id}>
              <td>
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedLeads.includes(id)} />
                  <label className="form-check-label"></label>
                </div>
              </td>
              <td>
                <i className="ri-user-fill"></i>&nbsp;{" "}
                <button
                  className="capitalize clio-name"
                  onClick={() => {
                    if (!viewLead.find((lead) => lead.id === id)) {
                      fetchLeadDetails(id);
                    }
                  }}
                >
                  {name.toLowerCase()}
                </button>
              </td>
              <td>
                {emails ? (
                  <a href={`mailto:${emails}`}>
                    {emails} &nbsp; <i className="ri-mail-send-line"></i>
                  </a>
                ) : (
                  "--"
                )}
              </td>
              <td>
                {phone_numbers ? (
                  <a href={`tel:+1${phone_numbers}`}>
                    {formatUSPhoneNumber(phone_numbers)} &nbsp; <i className="ri-phone-fill"></i>
                  </a>
                ) : (
                  "--"
                )}
              </td>
              <td>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ width: "80px", height: "8px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                    <p
                      className="progress-bar-animate"
                      style={{
                        "--target-width": inProgressWidth,
                        "--bar-color": inBarColor,
                      }}
                    ></p>
                  </div>
                  <span onMouseEnter={() => setHoverContent({ client_zoom_calls, direction: "inbound" })} className="call-count">
                    {Inbound}/{Inbound > 12 ? Inbound : 12}
                    {/* <div className="call-count-hover-text">
                        <table>
                          <thead>
                            <th>Name</th>
                            <th>Duration</th>
                            <th>Date</th>
                          </thead>
                          <tbody>
                            {(client_zoom_calls || [])
                              .filter((call) => call.direction === "inbound")
                              .slice(0, 10)
                              .map((call, index) => (
                                <tr>
                                  <td> {call.to_name || "--"}</td>
                                  <td>{call.duration}</td>
                                  <td>{formatDateTime(call.start_time)}</td>
                                </tr>
                              ))}

                            {(client_zoom_calls || []).filter((c) => c.direction === "inbound").length === 0 && (
                              <tr>
                                <td colSpan="3">No inbound calls</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div> */}
                  </span>
                </div>
              </td>
              <td>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ width: "80px", height: "8px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                    <p
                      className="progress-bar-animate"
                      style={{
                        "--target-width": progressWidth,
                        "--bar-color": barColor,
                      }}
                    ></p>
                  </div>
                  <span onMouseEnter={() => setHoverContent({ client_zoom_calls, direction: "outbound" })} className="call-count">
                    {Outbound}/{Outbound > 12 ? Outbound : 12}
                  </span>
                </div>
              </td>
              <td>{source_name || "--"}</td>
              <td>{assignedto ? `${assignedto.name}` : "--"}</td>
              <td>{formatDateTime(created_at)}</td>
            </tr>
          );
        })}
      </>
    );
  };

  const leadsLoadingView = () => {
    return (
      <tr className="loading-hover loading-grid">
        <td className="property-loader preloader">
          <PulseLoader color="#4180ad" />
        </td>
      </tr>
    );
  };

  const noLeadsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <a className="fs-28 avatar-title" style={{ lineHeight: "20px", marginBottom: "8px" }}>
            <i className="ri-file-warning-line"></i>
          </a>
          No Clio Grow Leads Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading && leadsList.status === "Success") {
      return leadsListView();
    } else if (isLoading) {
      return leadsLoadingView();
    } else if (leadsList.status === "Not Found") {
      return noLeadsView();
    } else if (leadsList.status === "Success") {
      return leadsListView();
    }
  };

  const renderItem = () => {
    const { name, emails, phone_numbers, source, status, type, created_at, assignedto_name } = modifiedLeadDetails;

    return (
      <form onSubmit={onHandleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input type="name" className="form-control" value={name} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input type="email" className="form-control" value={emails} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Phone</label>
          <InputMask mask="(999) 999 9999" value={phone_numbers} placeholder="(123) 456-7890" className="form-control" disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Assigned to</label>
          <input type="name" className="form-control" value={assignedto_name} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Source</label>
          <Dropdown
            className="customDropdown"
            name="source"
            value={source}
            onChange={(e) => onHandleEvent(e, setModifiedLeadDetails)}
            options={sourceList}
            optionValue="id"
            optionLabel="name"
            appendTo="self"
            placeholder="Add source"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Status</label>
          <input type="name" className="form-control" value={status} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Type</label>
          <input type="name" className="form-control" value={type} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label">Created Date</label>
          <input type="name" className="form-control" value={formatDateTimeNew(created_at)} disabled />
        </div>
        <div className="page-title-box">
          <button type="submit" className="btn btn-primary btn-blue">
            Submit
          </button>
        </div>
      </form>
    );
  };

  const handleReset = () => {
    setZoomSearchValues({ searchZoomValue: "" });
    setZoomFilter("inbound");
    setDates({ from: null, to: null });
  };

  const handleResetData = () => {
    setFilteredValues({
      searchValue: "",
      sourceFilter: "",
      assignedToValue: "",
    });
    setChangeType(0);
    setLeadDates({ from: null, to: null });
  };

  const leadFilters = () => {
    return (
      <div className="page-title-box-content">
        {selectedLeads.length > 0 && (
          <button type="button" className="page-title-btn custom-target-icon fs-18" data-pr-position="bottom" data-pr-tooltip="Delete">
            <i className="ri-delete-bin-line"></i>
          </button>
        )}
        <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleReset}>
          <i className="ri-refresh-line"></i>
        </button>
        <div className="dates-group">
          <Calendar
            style={{ width: "230px", marginRight: "0" }}
            value={dates}
            onChange={(e) => setDates(e.value)}
            selectionMode="range"
            readOnlyInput
            hideOnRangeSelection
            placeholder="Date Range"
            dateFormat="M dd yy"
            showButtonBar
            showIcon
          />
        </div>
        <div className="app-search">
          <select className="form-select" value={zoomFilter} onChange={(e) => setZoomFilter(e.target.value)}>
            <option value=" ">All</option>
            <option value="inbound">Inbound</option>
            <option value="outbound">Outbound</option>
            <option value="no answer">No Answer</option>
          </select>
        </div>
        {/* <form className="app-search">
          <div className="position-relative">
            <input
              type="search"
              className="form-control border-0"
              placeholder="Search..."
              autoComplete="off"
              value={zoomSearchValues.searchZoomValue || ""}
              onChange={(e) => setZoomSearchValues({ searchZoomValue: e.target.value })}
            />
            <i className="ri-search-line search-widget-icon"></i>
          </div>
        </form> */}
      </div>
    );
  };

  const renderLeadDetails = (item) => {
    const {
      id,
      name,
      created_at,
      emails,
      phone_numbers,
      status,
      source_name,
      type,
      InComing,
      Inbound,
      Outbound,
      Outgoing,
      Noanswer,
      Total_Calls,
      description,
      inBoundChartData,
      outBoundChartData,
      matter_data,
      assignedto,
    } = item;

    const OutTotal = Outbound > 12 ? Outbound : 12;
    const InTotal = Inbound > 12 ? Inbound : 12;
    const NoAnswer = Noanswer > 12 ? Noanswer : 12;
    const TotalCalls = Total_Calls > 12 ? Total_Calls : 12;

    return (
      <>
        <div id="popupSidebar" className="popup-sidebar lead-sidebar">
          <ul>
            <li>
              <span>Name</span> {name}
            </li>
            <li>
              <span>Phone</span> {phone_numbers ? <a href={`tel:+1${phone_numbers}`}>{formatUSPhoneNumber(phone_numbers)}</a> : "--"}
            </li>
            <li>
              <span>Email</span> {emails ? <a href={`mailto:${emails}`}>{emails}</a> : "--"}
            </li>
            <li>
              <span>Type</span>
              {type}
            </li>
            <li>
              <span>Status</span>
              {status}
            </li>
            <li>
              <span>Source</span> {source_name || "--"}
            </li>
            <li>
              <span>Assigned to</span>
              {assignedto ? `${assignedto.name}` : "--"}
            </li>
            <li>
              <span>Created</span> {formatDateTime(created_at)}
            </li>
            <li>
              <span>Matters</span> {matter_data ? matter_data.type || "--" : "--"}
            </li>
          </ul>
          <div className="des">
            <span>Matter description</span> <p>{matter_data ? matter_data.description || "--" : "--"}</p>
            {/* <p>
              The user, Rafael Rosales, is seeking legal assistance for an uncontested divorce. He states there are no children involved, no property or support disputes, and everything is amicable.{" "}
            </p> */}
          </div>
          <div className="des">
            <span>Call Progress</span>

            {(() => {
              let progressValue = 0,
                max = 12;
              if (zoomFilter === "inbound") {
                progressValue = Inbound;
                max = InTotal;
              } else if (zoomFilter === "outbound") {
                progressValue = Outbound;
                max = OutTotal;
              } else if (zoomFilter === "no answer") {
                progressValue = Noanswer;
                max = NoAnswer;
              } else {
                progressValue = Total_Calls;
                max = TotalCalls;
              }

              const barColor = progressValue <= 4 ? "red" : progressValue <= 8 ? "orange" : "green";

              return (
                <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "15px" }}>
                  <div style={{ width: "230px", height: "12px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                    <p
                      style={{
                        width: progressValue > 0 ? `${(progressValue / 12) * 100}%` : "4px",
                        height: "100%",
                        backgroundColor: barColor,
                        borderRadius: "10px",
                        transition: "width 0.3s ease-in-out",
                      }}
                    ></p>
                  </div>
                  <p style={{ marginBottom: "0" }}>
                    {progressValue}/{max}
                  </p>
                </div>
              );
            })()}
          </div>

          {zoomFilter !== "no answer" && (inBoundChartData?.data?.length > 0 || outBoundChartData?.data?.length > 0) && (
            <div className="des" style={{ minHeight: "216px" }}>
              <span>Call Duration</span>
              {(zoomFilter === "inbound" || zoomFilter === " ") && inBoundChartData?.data?.length > 0 && (
                <div className="chart-grid">
                  <div className="chart-data">
                    <p>
                      {Inbound}/{InTotal}
                    </p>
                    <CustomChart chartLabels={inBoundChartData?.labels} chartDetails={inBoundChartData?.data} />
                  </div>
                  <ul className="chart-list">
                    <li>
                      <span>
                        <b>Inbound</b>
                      </span>
                    </li>
                    <li>
                      <span>Total : </span>
                      {InTotal}
                    </li>
                    <li>
                      <span>Left : </span>
                      {InTotal - Inbound}
                    </li>
                    <li>
                      <span>Completed : </span>
                      {Inbound}
                    </li>
                  </ul>
                </div>
              )}
              {(zoomFilter === "outbound" || zoomFilter === " ") && outBoundChartData?.data?.length > 0 && (
                <div className="chart-grid">
                  <div className="chart-data">
                    <p>
                      {Outbound}/{OutTotal}
                    </p>
                    <CustomChart chartLabels={outBoundChartData?.labels} chartDetails={outBoundChartData?.data} />
                  </div>
                  <ul className="chart-list">
                    <li>
                      <span>
                        <b>Outbound</b>
                      </span>
                    </li>
                    <li>
                      <span>Total : </span>
                      {OutTotal}
                    </li>
                    <li>
                      <span>Left : </span>
                      {OutTotal - Outbound}
                    </li>
                    <li>
                      <span>Completed : </span>
                      {Outbound}
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}

          <div className="des des-list">
            <span>Call Information</span>
            <ul>
              <li>
                Inbound <span>{Inbound}</span>
              </li>
              <li>
                Outbound <span>{Outbound}</span>
              </li>
              <li>
                No Answer <span>{Noanswer}</span>
              </li>
            </ul>
          </div>
        </div>
        <div id="popupContentGrid" className="popup-content-grid">
          <div id="activitySidebar" className="activity-bar">
            {activityTab === "zoomInfo" && (
              <>
                <table className="table align-middle text-nowrap table-hover table-centered property-table ">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>From</th>
                      <th>To</th>
                      <th>Start Time</th>
                      <th>Duration</th>
                      <th>Recorded</th>
                      <th>Direction</th>
                    </tr>
                  </thead>
                  {zoomCallsLoading[phone_numbers] ? (
                    <tbody>
                      <tr className="loading-hover">
                        <td className="property-loader preloader">
                          <PulseLoader color="#4180ad" />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {(zoomCalls[phone_numbers] || []).length > 0 ? (
                        zoomCalls[phone_numbers].map((call) => (
                          <tr key={call.id}>
                            <td>
                              <div className="form-check">
                                <input type="checkbox" className="form-check-input" />
                              </div>
                            </td>
                            <td className="capitalize">
                              {call.from_name ? <span className="clio-name">{call.from_name.toLowerCase()}</span> : ""}
                              <br />
                              <a href={`tel:+1${call.from_phone_number}`}>{formatUSPhoneNumber(call.from_phone_number)}</a> &nbsp; {call.from_ext ? <>Ext.{call.from_ext}</> : ""}
                            </td>
                            <td className="capitalize">
                              {call.to_name ? <span className="clio-name">{call.to_name.toLowerCase()}</span> : ""}
                              <br />
                              <a href={`tel:+1${call.to_phone_number}`}>{formatUSPhoneNumber(call.to_phone_number)}</a> &nbsp; {call.to_ext ? <>Ext.{call.to_ext}</> : ""}
                            </td>
                            <td>{formatDateTime(call.start_time)}</td>
                            <td>{call.duration || "--"}</td>
                            <td>{call.recorded === "y" ? "Yes" : "No"}</td>
                            <td>{call.direction}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            No zoom call data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </>
            )}
            {activityTab === "moreInfo" && <h4>Notes</h4>}
          </div>
        </div>
        <div className="activity-bar-ribbon">
          <div className="activity-list">
            <button
              onClick={() => {
                setActivityTab("zoomInfo");
              }}
              className={`activityInfo-button fadeUp ${activityTab === "zoomInfo" ? "active" : ""}`}
              style={{ animationDelay: "0.5s" }}
            >
              <i className="ri-phone-fill"></i>
              <span>Calls</span>
            </button>
            <button
              onClick={() => {
                setActivityTab("moreInfo");
              }}
              className={`activityInfo-button fadeUp ${activityTab === "moreInfo" ? "active" : ""}`}
              style={{ animationDelay: "0.8s" }}
            >
              <i className="ri-add-line"></i>
              <span>Notes</span>
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">
                Clio Grow <span>({leadsList?.pagination?.total || 0}) </span>
              </h4>
              <div className="page-title-box-content">
                {selectedLeads.length > 0 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18">
                    <i className="ri-delete-bin-line"></i>
                  </button>
                )}
                {selectedLeads.length === 1 && (
                  <button
                    type="button"
                    className="page-title-btn custom-target-icon fs-18"
                    onClick={() => {
                      navigate(`edit/${selectedLeads[0]}`);
                      const selectedLeadData = leadsList.data.filter((lead) => lead.id === selectedLeads[0])[0];
                      setModifiedLeadDetails(selectedLeadData);
                    }}
                  >
                    <i className="ri-edit-2-line"></i>
                  </button>
                )}
                <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleResetData}>
                  <i className="ri-refresh-line"></i>
                </button>
                <Calendar
                  value={leadDates}
                  onChange={(e) => setLeadDates(e.value)}
                  selectionMode="range"
                  readOnlyInput
                  hideOnRangeSelection
                  placeholder="Date Range"
                  dateFormat="M dd yy"
                  showButtonBar
                  showIcon
                />
                <div className="app-search">
                  <Dropdown
                    name="sourceFilter"
                    value={filteredValues.sourceFilter}
                    onChange={(e) => onHandleEvent(e, setFilteredValues)}
                    options={sourceList || [{ id: "", name: "" }]}
                    optionValue="id"
                    optionLabel="name"
                    appendTo="self"
                    placeholder="Filter by source"
                  />
                </div>
                {user?.role === 1 ? (
                  <div className="app-search">
                    <Dropdown
                      name="assignedToValue"
                      value={filteredValues.assignedToValue}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      options={clioUserList}
                      optionValue="id"
                      optionLabel="name"
                      appendTo="self"
                      placeholder="Filter by assignee"
                    />
                  </div>
                ) : (
                  ""
                )}
                {/* <div className="app-search">
                  <Dropdown className="customDropdown" value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={statusOptions} optionLabel="name" appendTo={"self"} />
                </div> */}
                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedLeads(leadsList.data.map((lead) => lead.id));
                              } else {
                                setSelectedLeads([]);
                              }
                            }}
                            checked={leadsList?.data?.length > 0 && selectedLeads.length === leadsList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Inbound </th>
                      <th>Outbound calls</th>
                      <th>Source</th>
                      <th>Assigned to</th>
                      <th>Created Date</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {leadsList?.pagination?.total && (
          <div className="pagination-grid">
            <div className="pagination-new">
              <span className="pagination-count">
                {leadsList.pagination !== undefined ? leadsList.pagination.from : 1}-{leadsList.pagination !== undefined ? leadsList.pagination.to : 50} &nbsp;of &nbsp;
                {leadsList.pagination !== undefined ? leadsList.pagination.total : 0}
              </span>

              <button
                type="button"
                className="pagination-btn pagination-prev"
                onClick={() => {
                  setPaginationObj((prevState) => ({ ...prevState, current: prevState.current - 1 }));
                }}
                disabled={paginationObj.current === 1}
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                type="button"
                className="pagination-btn pagination-next"
                onClick={() => {
                  setPaginationObj((prevState) => ({ ...prevState, current: prevState.current + 1 }));
                }}
                disabled={paginationObj.current === leadsList?.pagination?.last_page}
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        )}

        {selectedLeads.length === 1 && (
          <CustomModal renderItem={renderItem} title="Edit Lead" showHeader={true} position="right" visible={pathname.toLowerCase().includes(`edit/${selectedLeads[0]}`)} />
        )}
        <div className="minimize-grid">
          {viewLead.length >= 1 &&
            viewLead.map((item) => (
              <CustomModal
                key={item.id}
                renderItem={() => renderLeadDetails(item)}
                title={"Lead Overview"}
                secondaryTitle={item.name.toLowerCase()}
                getModalLayout={setGetModalLayout}
                filters={leadFilters}
                visible={true}
                showLeftSidebarIcon={true}
                showLayoutIcon={viewLead.length === 1}
                onHandleClose={() => {
                  const modifiedData = viewLead.filter((lead) => lead.id !== item.id);
                  setViewLead(modifiedData);
                  // handleReset();
                }}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Leads;
